import 'whatwg-fetch';

export default {
  loadLocaleMessages: async function (url) {
    // Fetch API cannot be used to load JavaScript modules
    // unless we wrap them with instantiated <script> elements.
    // If Fetch API is not available, we can use axios.
    try {
      let response = await fetch(url, {
		credentials: 'same-origin', // cookies/credentials need to be included if an identity context is required on the server.
        headers: {
          'Accept': 'application/json'
        }
      });
      let json = await response.json();
      if (typeof json !== 'object') {
        throw new Error(`loading ${url}`);
      }
      return json;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
};
